





























































































helpers = require('../../helpers.coffee')

view_model = {
  components:
    tag: require('../tags/tag')

  data: ->
    current_user: Session.current_user
    is_bar_minimized: false
    description_num_of_char: 70
    show_full_comments: {}
    all_comments: false
    contact: new Contact
    loading: true
    task: null
    show_sidebar: false
    action_human_signature: {
      "task-flow-action-social-task": "Social"
      "task-flow-action-phonecall-task": "Ligação"
      "task-flow-action-linkedin-task": "LinkedIn"
      "task-flow-action-email-task": "E-mail"
      "email-flow-action": "E-mail"
    }

  methods:
    newComment: (open_anyway = false) ->
      @open_anyway = open_anyway
      if @task && @task.id
        @task_resources.get @loadTaskSuccess, @unknownError, id: @task.id
      else
        EventsBus.$emit 'Comment::New', { contact: @contact, template: null }

    loadTaskSuccess: (data) ->
      @task = data.task
      if @task.template.id
        EventsBus.$emit 'Comment::New', { contact: @contact, template: @task.template }
      else if @open_anyway
        EventsBus.$emit 'Comment::New', { contact: @contact, template: null }

    editComment: (comment) ->
      EventsBus.$emit 'Comment::Edit', { comment: comment, contact: @contact }

    openTagsModal: ->
      EventsBus.$emit 'open-tag-picker-modal', @contact

    removeTag: (data) ->
      params = { id: @contact.id, contact_tags_attributes: [{ id: data.taggable_tag_id, _destroy: true }] }
      @contact_resources.update @removeTagSuccess(data), @unknownError, params

    removeTagSuccess: (data) ->
      (response) =>
        alertify.success 'Tag removida com sucesso!'
        EventsBus.$emit 'update-tags', data

    updateTags: (data) ->
      @contact.tags = @contact.tags.filter (tag) ->
        tag.taggable_tag_id != data.taggable_tag_id

    updateContact: (contact) ->
      @contact = contact

    openDialer: (number, number_type, task) ->
      event.originalEventName = 'open-dialer'
      data = { contact: @contact, task: null, number: number, number_type: number_type }
      EventsBus.$emit 'open-dialer', data

    seeMoreComment: (comment) ->
      if @show_full_comments[comment.id]
        Vue.set(@show_full_comments, comment.id.toString(), !@show_full_comments[comment.id.toString()])
      else
        Vue.set(@show_full_comments, comment.id.toString(), true)

    toggle: (data) ->
      if data.contact_id
        contact_id = data.contact_id
        @task = data.task
      else
        contact_id = data
      if contact_id == @contact.id
        @close(contact_id)
      else
        @open(contact_id)
        @newComment() if data.open_comment

    open: (contact_id) ->
      @loading = true
      @loadContact(contact_id)
      @is_bar_minimized = false
      @all_comments = false
      @show_full_comments = {}
      @show_sidebar = true

    close: (contact_id) ->
      return unless (contact_id && contact_id == @contact.id) || !contact_id
      @contact = new Contact
      @show_sidebar = false

    reload: (contact_id) ->
      @open(contact_id) if @show_sidebar

    minimize: ->
      @is_bar_minimized = true

    showAllComments: ->
      @all_comments = !@all_comments

    restore: ->
      @is_bar_minimized = false

    shortDescription: (content) ->
      result = @strippedContent(content)
      if result != null && result.length > @description_num_of_char
        result.substring(0, @description_num_of_char) + '...'
      else
        if result.length > 0
          result
        else
          '[imagem]'

    strippedContent: (content) ->
      regex = /(<([^>]+)>)/ig
      result = content.replace(/<\/p><p>/gm, "&nbsp;")
      result = result.replace(regex, "")
      result.replace(/&nbsp;/gi,' ')

    loadContact: (contact_id) ->
      @loading = true
      @contact_resources.summary @loadContactSuccess, @unknownError, id: contact_id

    loadContactSuccess: (data) ->
      @contact = data.contact
      @loading = false
      EventsBus.$emit 'reload-contact', @contact

    flowActionDescription: (interaction) ->
      description = "#{interaction.step + 1}/#{@contact.flow.actions_count} #{interaction.template_name}"
      if description.length > 33 then description.substring(0, 30) + '...' else description

    templateDescription: (name) ->
      if name.length > 33 then name.substring(0, 30) + '...' else name

    removeComment: (comment) ->
      @contact.comments.remove(comment.id)

    updateComments: (comment) ->
      @contact.comments.remove(comment.id)
      @contact.comments.unshift comment

    absoluteUrl: (url) ->
      fixed_url = url
      reg = /^((http|https|ftp):\/\/)/
      fixed_url = "http://" + url if !reg.test(url)
      fixed_url

    updateLoading: (loading) ->
      if loading then Loader.on() else Loader.off()

  computed:
    linkedin_user_name: ->
      regex = /(?:https?:\/\/)?(?:www.)?linkedin.com\/in\/([0-9A-z-]+)[\/?\s$]?/
      result = regex.exec(@contact.linkedin)
      if result
        result[1]
      else
        @contact.linkedin.substring(0,30)+ '...' if @contact.linkedin

    comments: ->
      result = []
      if @contact.comments
        for comment in @contact.comments
          result.push comment
          return result unless @all_comments
      result

    interactions_count: ->
      interactions = @contact.interactions_with_current_flow
      return { open: "-", delivery: "-" } unless interactions && !(interactions instanceof Array)
      {
        open: interactions.total_open || "-"
        delivery: interactions.total_delivery || "-"
      }

    step_description: ->
      return "Não iniciado" unless @contact.recipient.human_last_flow_action_taken && @contact.flow.actions.length > 0
      signature = @contact.flow.actions[@contact.recipient.last_flow_action_taken].signature
      @action_human_signature[signature]

    flow_current_step_text: ->
      return "-" unless @contact.flow
      current_step = @contact.recipient.human_last_flow_action_taken || 0
      "#{current_step}/#{@contact.flow.actions_count} - #{@step_description.toUpperCase()}"

    subheader: ->
      return "-" unless @contact.position || @contact.business?.name
      return @contact.position if !@contact.business?.name
      return @contact.business.name if !@contact.position
      @contact.business.name + " - " + @contact.position

    has_open_interactions: ->
      interactions = @contact.interactions_with_current_flow
      interactions && !(interactions instanceof Array) && @contact.interactions_with_current_flow.total_open > 0

    has_business: ->
      @contact.business?.id != null

    business_subheader: ->
      return '' unless @has_business
      @contact.business.name

    position_subheader: ->
      if @has_business
        if @contact.position != null
          return ' - ' + @contact.position
        else
          return ''
      else
        if @contact.position != null
          return @contact.position
        else
          return '-'

  created: ->
    @contact_resources = new ContactsResource Session.current_company.id
    @task_resources = new TasksResource
    EventsBus.$on 'toggle-task-bar', @toggle
    EventsBus.$on 'reload-task-bar', @reload
    EventsBus.$on 'close-task-bar', @close
    EventsBus.$on 'update-contact', @updateContact
    EventsBus.$on 'update-tags', @updateTags
    EventsBus.$on 'Comment::Destroyed', @removeComment
    EventsBus.$on 'Comment::CreatedUpdated', @updateComments

  beforeDestroy: ->
    EventsBus.$off 'toggle-task-bar', @toggle
    EventsBus.$off 'reload-task-bar', @reload
    EventsBus.$off 'close-task-bar', @close
    EventsBus.$off 'update-contact', @updateContact
    EventsBus.$off 'update-tags', @updateTags
    EventsBus.$off 'Comment::Destroyed', @removeComment
    EventsBus.$off 'Comment::CreatedUpdated', @updateComments
}

exports.default = helpers.vue_include( view_model, helpers.form, helpers.contacts.list_view_modes, helpers.filters)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/task_bar.vue